import * as PIXI from 'pixi.js'
import * as filters from 'pixi-filters'
import Please from 'pleasejs'

const blur = new filters.KawaseBlurFilter(6, 8),
  contrast = new filters.AdjustmentFilter({ contrast: 80, brightness: 0.04, saturation: 0.5 })

const options = {
  width: window.innerWidth,
  height: window.innerHeight,
  transparent: true,
  antialias: true
}

const app = new PIXI.Application(options)
window.addEventListener('resize', () => {
  app.view.width = window.innerWidth
  app.view.height = window.innerHeight
}, false)

app.stage.filters = [blur, contrast, blur]
document.body.appendChild(app.view)

const circlePrototype = new PIXI.Graphics(), circles = []
circlePrototype.lineStyle(0)
circlePrototype.beginFill(0xfefefe, 1)
circlePrototype.drawCircle(0, 0, 100)
circlePrototype.endFill()
circlePrototype.cacheAsBitmap = true

for (let i = 0, max = 800; i < max; i++) {
  const circle = circlePrototype.clone()
  circle.width = randomInt(1, 500)
  circle.height = circle.width
  circle.x = randomInt(0, app.screen.width)
  circle.y = randomInt(0, app.screen.height)
  circle.direction = Math.random() * Math.PI
  circle.turningSpeed = Math.random()
  circle.speed = Math.random() 

  circle.alpha = Math.random()

  const color = Please.make_color({ 
    golden: false, 
    base_color: circle.width < 250 ? 
                '#95E0E1' : chance(.8)? 
                '#ffa500' : 'yellow'
  })
  circle.tint = parseInt(color[0].replace('#', ''), 16)

  circles.push(circle)
  app.stage.addChild(circle)
}

app.ticker.add(delta => {
  circles.forEach(circle => {
    circle.x += Math.sin(circle.direction) * circle.speed;
    circle.y += Math.cos(circle.direction) * circle.speed;
    circle.direction += circle.turningSpeed * delta * .01;
    circle.rotation = -circle.direction - Math.PI / 2
  })
})

function randomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function chance(probability = 0.5) {
  return Math.random() <= probability
}
